import { currentUser } from "@/App";
import AISummary from "@/components/AISummary";
import ArtistAccountTabs from "@/components/ArtistAccountTabs";
import CurrentUserDrawer from "@/components/CurrentUserDrawer";
import { Close } from "@mui/icons-material";
import {
  AppBar,
  Box,
  Container,
  IconButton,
  Stack,
  Toolbar,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import FrontRowContainer from "./FrontRowContainer";
import GenderContainer from "./GenderContainer";
import LocationsContainer from "./LocationsContainer";
import SubscriberChangeContainer from "./SubscriberChangeContainer";

export default function ArtistData() {
  return (
    <Container maxWidth="md" sx={{ py: 10 }}>
      <PageAppBar />
      <ArtistAccountTabs />
      <Box>
        <AISummary title="AI AUDIENCE SUMMARY" />
        <FrontRowContainer />
        <SubscriberChangeContainer />
        <LocationsContainer />
        <Stack
          direction={{ xs: "column", md: "row" }}
          spacing={4}
          sx={{ mt: 4 }}
        >
          <GenderContainer />
        </Stack>
      </Box>
    </Container>
  );
}

function PageAppBar() {
  const navigate = useNavigate();
  return (
    <AppBar
      position="fixed"
      elevation={0}
      style={{ background: "rgba(19,19,19,.9)" }}
    >
      <Toolbar style={{ display: "flex", justifyContent: "space-between" }}>
        <IconButton
          onClick={() => navigate(`/${currentUser.key}`)}
          sx={{ pl: 0 }}
        >
          <Close />
        </IconButton>

        <CurrentUserDrawer />
      </Toolbar>
    </AppBar>
  );
}
